import { Paper, Stack, useTheme } from '@mui/material';
import { OrganizationPatientUpcomingVisitCardContent } from 'src/sections/@dashboard/organization/components/OrganizationPatients/OrganizationPatient/OrganizationPatientUpcomingVisitCardContent';
import { OrganizationPatientVisitsHistoryContent } from 'src/sections/@dashboard/organization/components/OrganizationPatients/OrganizationPatient/OrganizationPatientVisitsHistoryContent';

export default function OrganizationPatientTabsVisitsHistoryPage() {
  const theme = useTheme();

  return (
    <Stack sx={{ height: 1, gap: 3 }}>
      <OrganizationPatientUpcomingVisitCardContent />
      <Paper
        sx={{
          borderRadius: 2,
          boxShadow: theme.customShadows.z8,
          height: '100%',
          // Paper defaults to background.paper, which is the very colour the
          // table's header row uses — on that card the header vanished into it.
          // The lighter default surface gives the header something to sit
          // against, matching the visit's own cards.
          backgroundColor: 'background.default',
        }}
      >
        <Stack sx={{ height: 1, minHeight: '560px' }}>
          <OrganizationPatientVisitsHistoryContent />
        </Stack>
      </Paper>
    </Stack>
  );
}
